import styled, { css } from 'styled-components'
import media from 'styled-media-query'
import cubes from 'assets/images/cubes.png'
import cubesMobile from 'assets/images/cubes-mobile.png'

export const About = styled.section`
  width: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  max-width: 1920px;
  margin: 100px auto 200px;

  ${media.lessThan('medium')`
    margin: 40px 0 70px 0;
    max-height: unset;
  `}
`

export const Wrapper = styled.div`
  width: 100%;
  max-width: 1100px;
  margin: 0 auto;
  position: relative;
  text-align: center;
`

export const Content = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  margin: 64px 0;

  ${media.lessThan('medium')`
    flex-direction: column;
    margin-bottom: 0;
  `}
`

export const ImageWrapper = styled.div`
  ${({ theme }) => css`
    width: 632px;
    -webkit-box-shadow: 20px 20px 0px 0px ${theme.colors.secondary.main};
    box-shadow: 20px 20px 0px 0px ${theme.colors.secondary.main};
    z-index: -1;

    ${media.lessThan('medium')`
      width: 90vw;
      margin-top: 20px;
      -webkit-box-shadow: 8px 8px 0px 0px ${theme.colors.secondary.main};
      box-shadow: 8px 8px 0px 0px ${theme.colors.secondary.main};
      margin: ${theme.spacings.xxsmall} auto ${theme.spacings.small};
    `}
  `}
`

export const Video = styled.div`
  position: relative;
  width: 100%;
  padding-bottom: 56.25%;

  ${media.lessThan('medium')`
    object-fit: cover;
  `}
`

export const Iframe = styled.iframe`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  background-color: transparent;
  border: none;
`

export const Paragraph = styled.div`
  width: 35vw;
  flex-direction: column;
  text-align: left;
  margin-right: 40px;

  ${media.lessThan('medium')`
    width: 100vw;
    margin-right: 0;
  `}
`

export const TitleWrapper = styled.div`
  &:before {
    content: '';
    position: absolute;
    top: 20px;
    background-image: url(${cubes});
    background-repeat: no-repeat;
    z-index: 1;
    width: 339px;
    height: 64px;

    ${({ locale }) =>
      locale == 'en'
        ? css`
            transform: translateX(70px);
          `
        : css`
            transform: translateX(50px);
          `}

    ${media.lessThan('medium')`
      background-image: url(${cubesMobile});
      height: 40px;
      top: 13px;

      ${({ locale }) =>
        locale == 'en'
          ? css`
              width: 95px;
              transform: translateX(60px);
            `
          : css`
              width: 95px;
              transform: translateX(50px);
            `}
    `}
  }
`

export const AboutTitle = styled.div`
  ${({ theme }) => css`
    position: relative;
    font-family: ${theme.font.familyTertiary};
    font-weight: ${theme.font.black};
    font-size: 48px;
    justify-content: center;
    color: ${theme.colors.primary.main};
    line-height: ${theme.spacings.large};
    line-height: 1.4;

    ${media.lessThan('medium')`
      font-size: 32px;
    `}
  `}
`

export const TextWrapper = styled.div`
  line-height: 1.4;

  ${media.lessThan('medium')`
    padding: 0 32px;
  `}
`

export const Text = styled.div`
  margin-bottom: 16px;
  line-height: 1.4;
`

export const Space = styled.div`
  line-height: 1.4;
`
